import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';
import { ArrowsClockwise, CheckCircle, WarningCircle, ArrowSquareOut } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function MenusMigradosPage() {
  const [weeks, setWeeks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState('');

  const fetchWeeks = useCallback(async () => {
    try { const { data } = await axios.get(`${API}/api/admin/migrated-baby-menus`); setWeeks(data || []); } catch { toast.error('Erro ao carregar'); } finally { setLoading(false); }
  }, []);
  useEffect(() => { fetchWeeks(); }, [fetchWeeks]);

  const markReviewed = async (weekId) => {
    setMarking(weekId);
    try {
      await axios.post(`${API}/api/baby-menus/${weekId}/mark-reviewed`);
      toast.success('Semana marcada como revista');
      setWeeks(prev => prev.filter(w => w.week_id !== weekId));
    } catch (e) { toast.error(e.response?.data?.detail || 'Erro'); }
    finally { setMarking(''); }
  };

  return (
    <div className="fade-in" data-testid="menus-migrados-page">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-2xl bg-amber-100 flex items-center justify-center"><ArrowsClockwise size={22} className="text-amber-700" weight="duotone" /></div>
        <div>
          <h2 className="font-heading font-medium text-2xl text-brand-text">Menus de Bebé Migrados</h2>
          <p className="text-sm text-brand-muted mt-0.5">Semanas convertidas automaticamente de ementas de adulto - confirma os grupos alimentares antes de dar como concluídas.</p>
        </div>
      </div>

      {loading ? (
        <p className="text-center py-12 text-brand-muted">A carregar...</p>
      ) : weeks.length === 0 ? (
        <div className="text-center py-16 bg-white border border-dashed border-brand-border rounded-2xl mt-6" data-testid="no-migrated-menus">
          <CheckCircle size={48} className="mx-auto text-brand-green mb-3" weight="duotone" />
          <p className="text-brand-muted">Sem menus migrados pendentes de revisão.</p>
        </div>
      ) : (
        <div className="space-y-3 mt-6">
          {weeks.map(w => (
            <div key={w.week_id} className="bg-white border border-brand-border rounded-2xl p-4" data-testid={`migrated-week-${w.week_id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0">
                  <p className="text-sm font-medium text-brand-text">{w.patient_name} <span className="text-brand-muted">· {w.label}</span></p>
                  <p className="text-xs text-brand-muted mt-0.5">{w.focus}</p>
                  {w.pending_meals > 0 && (
                    <p className="text-[11px] text-amber-600 flex items-center gap-1 mt-1.5" data-testid={`pending-meals-${w.week_id}`}>
                      <WarningCircle size={13} weight="duotone" /> {w.pending_meals} refeição{w.pending_meals !== 1 ? 'ões' : ''} sem grupos alimentares definidos
                    </p>
                  )}
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <Link to={`/admin/pacientes/${w.patient_id}`} className="text-xs text-brand-green font-medium flex items-center gap-1 hover:underline no-underline" data-testid={`open-patient-${w.week_id}`}>
                    Abrir ficha (separador Ementa Bebé) <ArrowSquareOut size={13} />
                  </Link>
                  <button onClick={() => markReviewed(w.week_id)} disabled={marking === w.week_id} className="bg-brand-green text-white rounded-full px-3 py-1.5 text-xs font-medium disabled:opacity-60" data-testid={`mark-reviewed-${w.week_id}`}>
                    {marking === w.week_id ? 'A marcar…' : 'Marcar como revisto'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
